import { render, staticRenderFns } from "./CustomerInformationDemo.vue?vue&type=template&id=e9f5dab0&scoped=true"
import script from "./CustomerInformationDemo.vue?vue&type=script&lang=js"
export * from "./CustomerInformationDemo.vue?vue&type=script&lang=js"
import style0 from "./CustomerInformationDemo.vue?vue&type=style&index=0&id=e9f5dab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f5dab0",
  null
  
)

export default component.exports